import React from 'react';
import './index.css';
import Rule from './alarmrule.js';
import Record from './alarmrecord.js';
import Contacts from './alarmcontacts.js';
import { Route } from 'react-router-dom';

class Content extends React.Component {
  constructor(){
    super();
    this.state = {
      typeList : false
    }
  }
  render(){
    const { parent, menu } = this.props;
    let done = true;
    let tab = '';
    switch(menu) {
      case '/devicealarm/alarmrule':
        tab = Rule;
        break;
      case '/devicealarm/alarmrecord':
        tab = Record;
        break;
      case '/devicealarm/alarmcontacts':
        tab = Contacts;
        break;
    }
    return (
      <div id="manageMain" className="content-main">
        {  (parent === menu) && done ?
          <Route path={ window.path } component={ tab } /> :<Route path={ window.path } component={ tab } />
        }
      </div>
    )
  }
}
export default Content;



// WEBPACK FOOTER //
// ./src/component/devicealarm/content.js